var path = '/home/marialelinux/projects/www.enplug.com/src/templates/checkout.tpl.html';
var html = "<div class=\"w-container\">\n    <checkout-directive  data=\"data\" taxrate=\"taxRate\"></checkout-directive>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;